//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    steps () {
      return this.$t('foodTest.howItWorks.steps')
    },
    buttonSize () {
      return this.isTablet() ? 'sm' : 'md'
    }
  },
  methods: {
  }
}
